import React, { useState } from 'react';
import { Copy, Facebook, Link2, MessageCircleMore, Share2 } from 'lucide-react';
import './ShareMenuButton.css';

const iconMap = {
    Facebook,
    X: Link2,
    WhatsApp: MessageCircleMore,
    Copy: Copy
};

const platforms = ['Facebook', 'X', 'WhatsApp', 'Copy'];

const ShareMenuButton = ({
    onShare,
    className = '',
    menuClassName = '',
    buttonLabel = 'Share',
    direction = 'down',
    align = 'right'
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleShare = async (platform) => {
        await onShare?.(platform);
        setIsOpen(false);
    };

    return (
        <div className={`share-menu-wrap ${className}`.trim()}>
            <button
                type="button"
                className="share-menu-trigger"
                onClick={() => setIsOpen((previous) => !previous)}
            >
                <Share2 size={15} className="me-2" />
                {buttonLabel}
            </button>
            {isOpen && (
                <div className={`share-menu-popover share-menu-popover-${direction} share-menu-popover-align-${align} ${menuClassName}`.trim()}>
                    {platforms.map((platform) => {
                        const Icon = iconMap[platform];
                        return (
                            <button key={platform} type="button" onClick={() => handleShare(platform)}>
                                <Icon size={15} />
                                {platform === 'Copy' ? 'Copy Link' : platform}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default ShareMenuButton;
